<h2 mat-dialog-title translate>
  {{
    type === 'save' || type === 'save_rack'
      ? 'dialog.password.title'
      : type === 'send' || type === 'EIC'
      ? 'dialog.password.title2'
      : 'dialog.password.title3'
  }}
</h2>
<mat-divider class="dialog__divider--top"></mat-divider>
<mat-dialog-content>
  <p *ngIf="this.type != 'EIC'" translate>dialog.password.text1</p>
  <form [formGroup]="passwordForm">
    <div *ngIf="this.type != 'EIC'">
      <p><strong translate>dialog.password.input</strong></p>
      <mat-form-field appearance="outline">
        <mat-label translate>dialog.password.placeholder</mat-label>
        <input
          id="passwordInputPasswordDialog"
          type="password"
          matInput
          formControlName="password"
          autocomplete="off"
        />
      </mat-form-field>
    </div>
    <mat-checkbox
      id="checkCondicionesPasswordDialog"
      color="accent"
      [checked]="checked"
      (change)="checked = !checked"
      aria-label="Aceptar firma"
      name="checkCondiciones"
      (click)="onclick()"
      formControlName="checkObservations"
      *ngIf="type != 'save_rack' && type != 'EIC'"
    >
      <span translate>request.observationsCheck</span>
      <br />
      <span id="downloadCondicionesCheckPasswordDialog" *ngIf="passwordForm.valid"
        ><a color="accent" href="javascript:void(0)" (click)="download()">{{
          'dialog.password.downloadAuth' | translate
        }}</a></span
      >
    </mat-checkbox>
    <div *ngIf="this.type === 'EIC'">
      <p translate>dialog.type.forwarding</p>
      <mat-radio-group formControlName="typeLink" class="dialog__list" [(ngModel)]="typeLinkSelected">
        <mat-radio-button [value]="'email'" *ngIf="showTypelink === 0 || showTypelink === 2"> Email </mat-radio-button>
        <mat-radio-button [value]="'SMS'" *ngIf="showTypelink === 0 || showTypelink === 1"> SMS </mat-radio-button>
      </mat-radio-group>
    </div>
  </form>
</mat-dialog-content>
<mat-divider class="dialog__divider--top"></mat-divider>
<mat-dialog-actions>
  <button id="closeButtonPasswordDialog" mat-stroked-button color="accent" class="btnMobile" (click)="exit()">
    <span>{{ 'dialog.password.button2' | translate | uppercase }}</span>
  </button>
  <button
    id="acceptButtonPasswordDialog"
    mat-flat-button
    color="accent"
    class="btnMobile"
    [disabled]="!passwordForm.valid"
    (click)="accept()"
  >
    <span style="text-transform: uppercase" translate>{{
      type === 'save' || type === 'save_rack'
        ? 'dialog.password.button1'
        : type === 'send' || type === 'EIC'
        ? 'dialog.password.button3'
        : 'dialog.password.button4'
    }}</span>
  </button>
</mat-dialog-actions>
